import React from 'react';

export default function CartItem({ item, onUpdate, onRemove }) {
  const { id, product, quantity, price, total, meta } = item;

  return (
    <div
      className="cart-item d-flex align-items-center justify-content-between border-bottom py-3"
      style={{ gap: 16 }}
    >
      <div className="d-flex align-items-center" style={{ gap: 16 }}>
        <img
          src={product.thumbnail || product.product_image}
          alt={product.name}
          style={{
            width: 100,
            height: 100,
            objectFit: 'cover',
            borderRadius: 8,
            border: '1px solid #eee',
          }}
        />
        <div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>{product.name}</div>
          {meta && (
            <div style={{ fontSize: 13, color: '#666' }}>
              {Object.entries(meta)
                .map(([k, v]) => `${k}: ${v}`)
                .join(', ')}
            </div>
          )}

          <div className="mt-2 d-flex align-items-center" style={{ gap: 8 }}>
            <button
              className="btn btn-outline-secondary btn-sm rounded-circle"
              onClick={() => onUpdate(id, quantity - 1)}
              disabled={quantity <= 1}
            >
              −
            </button>
            <span style={{ minWidth: 30, textAlign: 'center' }}>{quantity}</span>
            <button
              className="btn btn-outline-secondary btn-sm rounded-circle"
              onClick={() => onUpdate(id, quantity + 1)}
            >
              +
            </button>
          </div>
        </div>
      </div>

      <div className="text-end">
        <div style={{ fontSize: 14, color: '#777' }}>Price: ₹{Number(price).toFixed(2)}</div>
        <div style={{ fontWeight: 700, fontSize: 16 }}>₹{Number(total).toFixed(2)}</div>
        <button
          className="btn btn-sm btn-outline-danger mt-2"
          onClick={() => onRemove(id)}
        >
          Remove
        </button>
      </div>
    </div>
  );
}
